import { Injectable } from '@angular/core';
import { Http, RequestOptionsArgs, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Constants } from '../constants';
import { Logger } from '../logger.service';
import { LoaderService, LoadProcess } from "../loader.service";
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpClient {
	private urlPrefix: string;

	constructor(private http: Http, private logger: Logger, private loaderService: LoaderService) {
		this.urlPrefix = ZUUL_BACKEND;
	}


	get(url): Observable<Response> {
		let loadProcess = new LoadProcess("GET " + url);
		this.loaderService.addProcess(loadProcess);

		let headers = this.createHeaders();
		let options = new RequestOptions({ headers: headers });
		let result = this.http.get(this.buildUrl(url), options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))
		return result;
	}

	delete(url): Observable<Response> {
		let loadProcess = new LoadProcess("DELETE " + url);
		this.loaderService.addProcess(loadProcess);

		let headers = this.createHeaders();
		let options = new RequestOptions({ headers: headers });
		let result = this.http.delete(this.buildUrl(url), options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}
	postRef(url: string, body: string): Observable<Response> {
		let loadProcess = new LoadProcess("POST REF " + url);
		this.loaderService.addProcess(loadProcess);

		let headers = this.createHeaders();
		headers.append('Content-Type', 'text/uri-list');
		let options: RequestOptions = new RequestOptions({ headers: headers });
		let result = this.http.post(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}

	putRef(url: string, refs: string[]): Observable<Response> {
		let loadProcess = new LoadProcess("PUT REF " + url);
		this.loaderService.addProcess(loadProcess);

		let body = "";
		if (refs) {
			body = refs.join("\n")
		}
		let headers = this.createHeaders();
		headers.append('Content-Type', 'text/uri-list');
		let options: RequestOptions = new RequestOptions({ headers: headers });
		let result = this.http.put(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}

	patchRef(url: string, refs: string[]): Observable<Response> {
		let loadProcess = new LoadProcess("PATCH REF " + url);
		this.loaderService.addProcess(loadProcess);

		let body = "";
		if (refs) {
			body = refs.join("\n")
		}
		let headers = this.createHeaders();
		headers.append('Content-Type', 'text/uri-list');
		let options: RequestOptions = new RequestOptions({ headers: headers });
		let result = this.http.patch(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}

	post(url: string, body?: string, options?: RequestOptionsArgs): Observable<Response> {
		let loadProcess = new LoadProcess("POST " + url);
		this.loaderService.addProcess(loadProcess);

		if (!options) {
			let headers = this.createHeaders();
			headers.append('Content-Type', 'application/json');
			headers.append('Accept', 'application/json');
			options = new RequestOptions({ headers: headers });
		}
		let result = this.http.post(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))
		return result;
	}

	put(url: string, body?: string, options?: RequestOptionsArgs): Observable<Response> {
		let loadProcess = new LoadProcess("PUT " + url);
		this.loaderService.addProcess(loadProcess);

		if (!options) {
			let headers = this.createHeaders();
			headers.append('Content-Type', 'application/json');
			options = new RequestOptions({ headers: headers });
		}
		let result = this.http.put(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
		.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}

	patch(url: string, body?: string, options?: RequestOptionsArgs): Observable<Response> {
		let loadProcess = new LoadProcess("PATCH " + url);

		if (!options) {
			let headers = this.createHeaders();
			headers.append('Content-Type', 'application/json');
			options = new RequestOptions({ headers: headers });
		}
		let result = this.http.patch(this.buildUrl(url), body, options)
			.do(this.saveTrackingHeader)
			.finally(() => this.loaderService.removeProcess(loadProcess))

		return result;
	}

	getFileAsBlob(url: string): Observable<Response> {
		let loadProcess = new LoadProcess("GET " + url);
		this.loaderService.addProcess(loadProcess);

		let headers = this.createHeaders();
		let options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		let result = this.http.get(this.buildUrl(url), options)
			.do(this.saveTrackingHeader)
			.finally(() => this.loaderService.removeProcess(loadProcess));
		return result;
	}


	private buildUrl(url: string) {
		if (url.startsWith("http://")) return url;
		if (url.startsWith("https://")) return url;
		if (url.indexOf("://") > -1) return url;
		else return this.urlPrefix + url;

	}

	private createHeaders(): Headers {
		let headers: Headers = new Headers();
		if (localStorage.getItem(Constants.SESSION_ID) != null) {
			headers.append(Constants.SESSION_ID_HEADER, localStorage.getItem(Constants.SESSION_ID));
		}
		if (localStorage.getItem("id_token")) {
			headers.append("Authorization", "Bearer " + localStorage.getItem("id_token"))
		}
		return headers;
	}

	private saveTrackingHeader = (response: Response) => {
		let requestId: string = response.headers.get(Constants.REQUEST_ID_HEADER);
		let sessionId: string = response.headers.get(Constants.SESSION_ID_HEADER);
		localStorage.setItem(Constants.REQUEST_ID, requestId);
		localStorage.setItem(Constants.SESSION_ID, sessionId);
	}

}



// WEBPACK FOOTER //
// ./src/app/services/webservice/http-client.service.ts